import axios from 'axios';

export default{
	namespaced:true,
	state:{
		analysisName:undefined,
		toDateRange:undefined,
		fromDateRange:undefined,
		audienceUrl:undefined,
		audienceList: [],
		totalAudiencesCount:undefined,
		width: 0,
		height: 0
	},

	actions:{
		getAudienceList({commit}, {monitor_uuid, page=1, size= 10}){
			return axios.get(`https://insightaudience.bindez.com/api/audience/monitor/${monitor_uuid}`,{
				params:{
					page,
					size
				}
			})
				.then(({data}) => {
					let{
						content,
						total_elements
					} = data;
					commit('setAudienceList',content);
					commit('setTotalAudiencesCount', total_elements)
				})
		}
	},

	getters:{},

	mutations:{
		setDetailAudience(state, audience){
			({
				analysis_name:state.analysisName,
				to_date:state.toDateRange,
				from_date:state.fromDateRange,
				url:state.audienceUrl,
				width:state.width,
				height: state.height
			} = audience)
		},

		setAudienceList(state, audienceList){
			state.audienceList = audienceList;
		},

		setTotalAudiencesCount(state, audiences){
			state.totalAudiencesCount = audiences
		}
	},
}
